import _ from 'lodash'
import { actionProcessSetProgress } from '../actions'
import { PROCESS_UPDATE } from '../constants'

function getRunningProcesses(state) {
    const { processes, servers: { active } } = state
    let list = []
    if (processes[active] !== undefined) {
        list = _.reduce(
            processes[active],
            (r, v, k) => {
                if (v.isRunning) r.push(k)
                return r
            },
            [],
        )
    }

    return list
}

const ClientProcessMiddleware = store => next => (action) => {
    switch (action.type) {
        case PROCESS_UPDATE: {
            // Get the current list of running clients
            const oldList = getRunningProcesses(store.getState())

            const result = next(action)

            // Get the new list of running clients
            const newList = getRunningProcesses(store.getState())
            const active = store.getState().servers.active

            // Now get a list of users that are in newList and not in prevList
            const newlyStartedProcesses = _.difference(newList, oldList)

            // Now I want to start a 10 second timer before calling
            newlyStartedProcesses.map(user =>
                setTimeout(() => {
                    store.dispatch(actionProcessSetProgress(active, user, 0))
                }, 10000),
            )

            const newlyStoppedProcesses = _.difference(oldList, newList)
            newlyStoppedProcesses.map(user =>
                store.dispatch(actionProcessSetProgress(active, user, 0)),
            )

            return result
        }

        default:
            return next(action)
    }
}

export default ClientProcessMiddleware



// WEBPACK FOOTER //
// ./src/middlewares/ClientProcessMiddleware.js